import React from "react";
import { Link } from "react-router-dom";
import { Button, Card, CardContent, Avatar } from "@mui/material";
import RMFDataGrid from "../shared/data-grid/RMFDataGrid";

const TemplateList = ({ templates }) => {
  console.log("TemplateList component rendered");
  const rows = templates || [];

  const columns = [
    {
      field: "image",
      headerName: " ",
      width: 60,
      renderCell: (params) => {
        return <Avatar src={params.row.image} />;
      },
    },
    { field: "name", headerName: "Name", width: 300 },
    {
      field: "id",
      headerName: "Action",
      width: 200,
      renderCell: (params) => (
        <Link to={`/edit-template/${params.row.id}`}>
          <Button variant="outlined" color="primary">
            Edit
          </Button>
        </Link>
      ),
    },
  ];

  return (
    <div>
      <h1>Templates</h1>
      <Link to="/add-template">
        <Button variant="contained" color="primary">
          Add Template
        </Button>
      </Link>
      <Card sx={{ mt: 1 }}>
        <CardContent>
          <RMFDataGrid data={rows} columns={columns} />
        </CardContent>
      </Card>
    </div>
  );
};

export default TemplateList;
